export default __webpack_public_path__ + "static/media/4.5ba76cb5.jpg";